module.exports = __webpack_public_path__ + "static/media/Magic_Chime_.67231960.mp3";